import { concat } from 'rxjs';
import { stow } from '@zambezi/caballo-vivo';
import { map, publishReplay, refCount, tap } from 'rxjs/operators';
import { createClearLoading$, createLoading$ } from '@apiEnabler/api-enabler-common/lib/loading';
import createRequest$ from './request';
var createGetEmployee$ = function createGetEmployee$() {
  return createRequest$('employee');
};
export var employee$ = concat(createLoading$('Loading initial data'), createGetEmployee$().pipe(map(expandEmployeePermissions), tap(validateSufficientPermissions), stow('employee')), createClearLoading$('Loading initial data')).pipe(publishReplay(1), refCount());
function expandEmployeePermissions(employee) {
  var permissions = employee.get('permissions').toSet();
  return employee.set('canReadPBB', permissions.has('OpenBanking-Consent-PBB-Read')).set('canReadCPB', permissions.has('OpenBanking-Consent-CPB-Read')).set('canWithdrawCPB', permissions.has('OpenBanking-Consent-CPB-Withdraw')).set('canWithdrawPBB', permissions.has('OpenBanking-Consent-PBB-Withdraw'));
}
function validateSufficientPermissions(employee) {
  if (employee.get('canReadPBB')) return;
  if (employee.get('canReadCPB')) return;
  throw Object.assign(new Error('Insufficient permissions to run app'), {
    type: 'insufficient-app-permissions'
  });
}